import React from 'react';
import * as S from './typography.styles';
import { TypographyProps } from './typography.types';

const defaultTagMap = {
  display1: 'h1',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  'body-16': 'p',
  'body-14': 'p',
  'body-12': 'p',
  'body-10': 'p',
} as const;

export const Typography = ({
  variant = 'body-16',
  as,
  children,
  fontWeight,
  fontFamily = 'General Sans',
  ...props
}: TypographyProps) => {
  // Use the provided 'as' prop or fall back to the default tag for the variant
  const tag = as || defaultTagMap[variant] || 'p';

  return (
    <S.Typography as={tag} $variant={variant} $fontWeight={fontWeight} $fontFamily={fontFamily} {...props}>
      {children}
    </S.Typography>
  );
};

Typography.displayName = 'Typography';
